import React from "react";
import { useTranslation } from "react-i18next";

import round from "astrid-helpers/src/round";

import Form from "../../../../forms/components/Form/Form";
import useSimpleForm from "../../../../forms/hooks/useSimpleForm";
import CurrencySelect from "../../../../prices/components/CurrencySelect/CurrencySelect";

export default function OrderCostsPriceForm({ cost, firstParty, onClose }) {
	const { t } = useTranslation();

	const { form, onSubmit, error } = useSimpleForm({
		values: {
			price: null,
			currency: null,
		},
		onSubmit: ({ price, currency }) => {
			const pricePerMinute = round(price / 60, 2);
			const total = pricePerMinute * cost.amount;

			return cost.ref.set(
				{
					price: {
						price: pricePerMinute,
						currency,
					},
					total,
				},
				{ merge: true },
			);
		},
		onSuccess: onClose,
	});

	return (
		<Form.Modal
			header={t("editPrice", "Edit price")}
			size="tiny"
			form={form}
			error={error}
			onSubmit={onSubmit}
			onClose={onClose}
		>
			<Form.Input
				name="price"
				label={`${t("price", "Price")} (${t("priceHour", "Per produced hour")})`}
				type="number"
			/>

			<Form.Field name="currency">
				<CurrencySelect label={t("currency", "Currency")} limitedOptions={firstParty?.currencyOptions} />
			</Form.Field>
		</Form.Modal>
	);
}
